export { };

// DATE EXTENSIONS
// ================

const meses = new Array('Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre');

declare global {
    interface Date {
        addDays(days: number, useThis?: boolean): Date;
        format(format: string): string;
        isToday(): boolean;
        clone(): Date;
        isAnotherMonth(date: Date): boolean;
        isWeekend(): boolean;
        isSameDate(date: Date): boolean;
    }
}

Date.prototype.format = function (format: string): string {
    const o = {
        // 'M+': this.getMonth() + 1, // month
        'd+': this.getDate(), // day
        'h+': (this.getHours() > 12) ? this.getHours() % 12 : this.getHours(), // hour 12h
        'H+': this.getHours(), // hour 24h
        'm+': this.getMinutes(), // minute
        's+': this.getSeconds(), // second
        'S+': this.getMilliseconds(), // millisecond,
        't+': (this.getHours() >= 12) ? 'PM' : 'AM',
        'q+': Math.floor((this.getMonth() + 3) / 3)  // quarter
    };

    for (const k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }


    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    if (/(M{2,})/.test(format)) {
        if (RegExp.$1.length < 3) {
            const m = this.getMonth() + 1;
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? m : ('00' + m).substr(('' + m).length));
        } else if (RegExp.$1.length > 1) {
            const m = meses[this.getMonth()];
            format = format.replace(RegExp.$1, RegExp.$1.length === 3 ? m.substr(0, 3) : m);
        }
    }

    return format;
};

Date.prototype.addDays = function (days: number) {
    if (!days) { return this; }
    const date = this;
    date.setDate(date.getDate() + days);

    return date;
};

Date.prototype.isToday = function (): boolean {
    const today = new Date();
    return this.isSameDate(today);
};

Date.prototype.clone = function (): Date {
    return new Date(+this);
};

Date.prototype.isAnotherMonth = function (date: Date): boolean {
    return date && this.getMonth() !== date.getMonth();
};

Date.prototype.isWeekend = function (): boolean {
    return this.getDay() === 0 || this.getDay() === 6;
};

Date.prototype.isSameDate = function (date: Date): boolean {
    return date && this.getFullYear() === date.getFullYear() && this.getMonth() === date.getMonth() && this.getDate() === date.getDate();
};
